"use client"

import { useEffect, useState } from "react"

const STORAGE_KEY = "site-language-selected"

function getLabel(locale: string | null) {
  if (locale === "ru-RU") {
    return "\u0421\u043c\u0435\u043d\u0438\u0442\u044c \u044f\u0437\u044b\u043a"
  }

  if (locale === "he-IL") {
    return "\u05d4\u05d7\u05dc\u05e3 \u05e9\u05e4\u05d4"
  }

  return "Change language"
}

export default function ChangeLanguageFooterLink() {
  const [locale, setLocale] = useState<string | null>(null)

  useEffect(() => {
    setLocale(localStorage.getItem(STORAGE_KEY))
  }, [])

  const handleClick = () => {
    window.dispatchEvent(new Event("open-language-modal"))
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className="text-sm text-gray-500 hover:text-black underline underline-offset-4"
    >
      {getLabel(locale)}
    </button>
  )
}